/*
 * Copyright (c) 2025 AirAsia Berhad (Malaysia). All rights reserved.
 *
 * This software is proprietary and confidential. Unauthorized copying of this file,
 * via any medium, is strictly prohibited. Do not distribute, copy, modify, or reuse
 * any part of this code without explicit written permission from AirAsia Move.
 *
 * For internal use only.
 */

import { AxiosRequestConfig, AxiosResponse } from 'axios';
import { RequestType } from '../types/request';

export abstract class HttpClient {
  constructor() {}

  abstract requestWithSchema<T = unknown>(
    config: RequestType,
  ): Promise<AxiosResponse<T>>;
  abstract request<T = unknown>(
    config: AxiosRequestConfig,
  ): Promise<AxiosResponse<T>>;
  abstract addUserAgent(appName: string, appVersion: string): void;
  abstract get<T = unknown>(
    url: string,
    config?: AxiosRequestConfig,
  ): Promise<AxiosResponse<T>>;
  abstract post<T = unknown>(
    url: string,
    data?: unknown,
    config?: AxiosRequestConfig,
  ): Promise<AxiosResponse<T>>;
  abstract put<T = unknown>(
    url: string,
    data?: unknown,
    config?: AxiosRequestConfig,
  ): Promise<AxiosResponse<T>>;
  abstract patch<T = unknown>(
    url: string,
    data?: unknown,
    config?: AxiosRequestConfig,
  ): Promise<AxiosResponse<T>>;
  abstract delete<T = unknown>(
    url: string,
    config?: AxiosRequestConfig,
  ): Promise<AxiosResponse<T>>;
  abstract handleError(error: unknown): {
    error: string;
    [key: string]: unknown;
  };
}
